import { inspectionClient } from '../config/api';
import {
  ProviderAcceptRequest,
  ProviderRejectRequest,
  ProviderAcceptResponse,
  ProviderRejectResponse,
  AssignInspectorRequest,
  ReassignInspectorRequest,
  AssignInspectorResponse,
  InspectorAcceptRequest,
  InspectorRejectRequest,
  InspectorAcceptResponse,
  InspectorRejectResponse,
} from './types/inspectionAssignment.types';
import { apiErrorHandler } from '@/helpers/apiErrorHandler';

class InspectionAssignmentService {
  
  async providerAccept(assignmentId: string, request: ProviderAcceptRequest): Promise<ProviderAcceptResponse> {
    try {
      const response = await inspectionClient.post<ProviderAcceptResponse>(
        `/api/InspectionAssignment/${assignmentId}/provider-accept`,
        request
      );
      
      return response.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao aceitar inspeção');
    }
  }

  async providerReject(assignmentId: string, request: ProviderRejectRequest): Promise<ProviderRejectResponse> {
    try {
      const response = await inspectionClient.post<ProviderRejectResponse>(
        `/api/InspectionAssignment/${assignmentId}/provider-reject`,
        request
      );

      return response.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao recusar inspeção');
    }
  }

  async assignInspector(assignmentId: string, request: AssignInspectorRequest): Promise<AssignInspectorResponse> {
    try {
      const response = await inspectionClient.post<AssignInspectorResponse>(
        `/api/InspectionAssignment/${assignmentId}/assign-inspector`,
        request
      );

      return response.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao direcionar inspeção para inspetor');
    }
  }

  async reassignInspector(assignmentId: string, request: ReassignInspectorRequest): Promise<AssignInspectorResponse> {
    try {
      const response = await inspectionClient.post<AssignInspectorResponse>(
        `/api/InspectionAssignment/${assignmentId}/reassign-inspector`,
        request
      );

      return response.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao redirecionar inspeção para inspetor');
    }
  }

  async inspectorAccept(assignmentId: string, request: InspectorAcceptRequest = {}): Promise<InspectorAcceptResponse> {
    try {
      const response = await inspectionClient.post<InspectorAcceptResponse>(
        `/api/InspectionAssignment/${assignmentId}/accept`,
        request
      );

      return response.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao aceitar inspeção');
    }
  }

  async inspectorReject(assignmentId: string, request: InspectorRejectRequest): Promise<InspectorRejectResponse> {
    try {
      const response = await inspectionClient.post<InspectorRejectResponse>(
        `/api/InspectionAssignment/${assignmentId}/reject`,
        request
      );

      return response.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao recusar inspeção');
    }
  }

  async forwardAutomaticToProvider(itemId: string, request: { providerId: string; notes?: string }): Promise<any> {
    try {
      const response = await inspectionClient.post(
        `/api/InspectionAssignment/item/${itemId}/forward-automatic-to-provider`,
        request
      );

      return response.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao encaminhar laudo automático para prestadora');
    }
  }

  async providerAcceptAutomatic(itemId: string): Promise<any> {
    try {
      const response = await inspectionClient.post(
        `/api/InspectionAssignment/item/${itemId}/provider-accept-automatic`
      );
      return response.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao aceitar demanda do laudo automático');
    }
  }

  async providerRejectAutomatic(itemId: string, notes?: string): Promise<any> {
    try {
      const response = await inspectionClient.post(
        `/api/InspectionAssignment/item/${itemId}/provider-reject-automatic`,
        { notes }
      );
      return response.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao recusar demanda do laudo automático');
    }
  }

  async assignCalculations(itemId: string, request: { providerId: string; notes?: string }): Promise<any> {
    try {
      const response = await inspectionClient.post(
        `/api/InspectionAssignment/item/${itemId}/assign-calculations`,
        request
      );

      return response.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao encaminhar cálculos para prestadora');
    }
  }

  async submitCalculations(itemId: string, request: { notes?: string } = {}): Promise<any> {
    try {
      const response = await inspectionClient.post(
        `/api/InspectionAssignment/item/${itemId}/submit-calculations`,
        request
      );

      return response.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao submeter cálculos');
    }
  }
}

export const inspectionAssignmentService = new InspectionAssignmentService();